import { render, staticRenderFns } from "./LoginService.vue?vue&type=template&id=70339c96&scoped=true"
import script from "./LoginService.vue?vue&type=script&lang=js"
export * from "./LoginService.vue?vue&type=script&lang=js"
import style0 from "./LoginService.vue?vue&type=style&index=0&id=70339c96&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70339c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70339c96')) {
      api.createRecord('70339c96', component.options)
    } else {
      api.reload('70339c96', component.options)
    }
    module.hot.accept("./LoginService.vue?vue&type=template&id=70339c96&scoped=true", function () {
      api.rerender('70339c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/components/LoginService.vue"
export default component.exports